import {
	HandwritingStyle,
	IAutomationStep,
	IAutomationStepReference,
	IBoardReference,
	IBoardStageReference,
	IFileAttachment,
	IRawRichTextContentState,
	ITemplateReference,
	ProcessStatus,
} from './';

import { FilterOperator } from '../../../extViewmodels';

export type AutomationStatus = {
	startedDate?: string;
	cancelledDate?: string;
	completedDate?: string;
	skippedDate?: string;
	errorMessage?: string;
	errorDate?: string;
	status: ProcessStatus;
	outcome?: string;
};

export type CommunicationStats = {
	emailsSent: number;
	emailReplies: number;
	emailsFailed: number;
	emailsBounced: number;
	textsSending: number;
	textsSent: number;
	textReplies: number;
	textsFailed: number;
	textNoNumberCount: number;
};

// API Source: https://github.com/Real-Magic/Levitate-API/blob/9933f885bb93af489285125346f97fb2419102ce/src/Levitate.Api.Models/Automation/TextingAutomationStepReference.cs#L6
export interface TextingAutomationStepReference extends IAutomationStepReference {
	content?: IRawRichTextContentState;
}

// API Source: https://github.com/Real-Magic/Levitate-API/blob/2ad143e4f082f5f6885866c2aab602c768eb9ffb/src/Levitate.Api.Models/Automation/TextingAutomationStep.cs#L3
export interface TextingAutomationStep extends IAutomationStep {
	content?: IRawRichTextContentState;
	attachments?: IFileAttachment[];
	sendAttachmentsAsLink?: boolean;
}

export type AutomationTemplateFilterCriteria = {
	criteria?: AutomationTemplateFilterCriteria[];
	op?: FilterOperator;
	property?: AutomationTemplateFilterProperty;
	value?: string | boolean;
};

export type AutomationTemplateFilter = AutomationTemplateFilterCriteria;

export enum AutomationTemplateFilterProperty {
	SingleStep = 'SingleStep',
	TriggerType = 'TriggerType',
	Status = 'Status',
	TemplateScope = 'TemplateScope',
	ParentTemplateId = 'ParentTemplateId',
	DraftSingleStep = 'DraftSingleStep',
	DraftTriggerType = 'DraftTriggerType',
}

/**
 * Contact filter properties used in automation flow condition filtering.
 * These represent contact attributes that can be used to filter which contacts
 * proceed through different paths in an automation flow.
 */
export enum AutomationContactFilterProperty {
	FirstName = 0,
	LastName = 1,
	Email = 2,
	Phone = 3,
	Company = 4,
	Title = 5,
	Tags = 6,
	Source = 7,
	Status = 8,
	Tag = 9,
	CustomField = 10,
}

export type AutomationTemplateFilterRequest = {
	filter: AutomationTemplateFilter;
};
export interface HandwrittenCardAutomationStep extends IAutomationStep {
	templateReference?: ITemplateReference;
	content?: IRawRichTextContentState;
	excludeSignature?: boolean;
	signature?: string;
	style?: HandwritingStyle;
}

export type OpportunityNameFormat = 'ContactAndCompany' | 'ContactOnly' | 'CompanyOnly';

export interface IOpportunityAutomationStep extends IAutomationStep {
	boardReference?: IBoardReference;
	boardStageReference?: IBoardStageReference;
	dealSize?: number;
	updateExistingOpportunity?: boolean;
	nameFormat?: OpportunityNameFormat | null;
}
